// extracted by mini-css-extract-plugin
export var cardLayout = "_9x-1";
export var paginationContainer = "_9x-0";